import axios from "axios";

const VERSION = "/v1/"

const SERVICE_URL: { [key: string]: string } = {
  STATION: "stationsvc",
  USER: "custsvc",
  PROFILE: "profilesvc",
  MEDIA: "mediasvc",
  EVENT: "eventsvc",
  CONTENT: "contentsvc",
  SHOW: "showsvc",
  CONTEST: "contestsvc",
  POLL: "pollsvc",
  FILE: "filesvc",
  USER_PREFERENCE: "userprefsvc",
  MASTER: "mstrsvc"
}

export const instance = (service: string) => {
  let baseURL = import.meta.env.VITE_API_URL + SERVICE_URL[service] + VERSION
  const serviceKey = `VITE_${service}_URL`
  if (import.meta.env[serviceKey]) {
    baseURL = import.meta.env[serviceKey] + SERVICE_URL[service] + VERSION
  }
  const instance = axios.create({
    baseURL
  });

  instance.interceptors.request.use(
    (config) => {
      const token = JSON.parse(localStorage.getItem("user") || "{}").token;
      if (token) config.headers.Authorization = `Bearer ${token}`;
      return config;
    },
    (error) => Promise.reject(error)
  );

  instance.interceptors.response.use(
    (response) => response, // Pass through successful responses
    async (error) => {
      if (error.response?.status === 401 && !error.config._retry) {
        error.config._retry = true;

        const refreshToken = JSON.parse(localStorage.getItem("user") || "{}").refreshToken;
        if (!refreshToken) {
          localStorage.removeItem("user");
          return Promise.reject(error);
        }

        try {
          const { data } = await axios.post(import.meta.env.VITE_API_URL + SERVICE_URL["USER"] + VERSION + "/refresh", {
            refreshToken,
          });

          localStorage.setItem("token", data.token);
          error.config.headers.Authorization = `Bearer ${data.token}`;
          return instance(error.config); // Retry the failed request with the new token
        } catch {
          localStorage.removeItem("user");
          return Promise.reject(error);
        }
      }

      return Promise.reject(error);
    }
  );

  return instance;
}